var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-flash-messages"},[_c('flash-messages')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }